// extracted by mini-css-extract-plugin
export var actionButton = "_c5-0";
export var attachmentLine = "_c5-1";
export var fileInput = "_c5-2";
export var fileUploadWrapper = "_c5-4";
export var footer = "_c5-3";
export var modalContent = "_c5-5";
export var paperclip = "_c5-6";
export var quillEditor = "_c5-7";